// Mouse-drag support for the product slider in the image-with-text section.
// Touch/pen keep the browser's native swipe scrolling; only mouse pointers are
// handled here. Uses delegated listeners so sliders rendered later (theme
// editor, section re-renders) work without re-initialization.
if (!window.imageWithTextProductsDragToSlide) {
  window.imageWithTextProductsDragToSlide = true;

  const SLIDER_SELECTOR = '.image-with-text__products-slider';
  const DRAG_THRESHOLD = 8;
  const SNAP_DELAY = 400;

  let drag = null;
  let suppressClickUntil = 0;

  const slideOffset = (slider) => {
    const slides = slider.querySelectorAll('[id^="Slide-"]');
    if (slides.length < 2) return 0;
    return slides[1].offsetLeft - slides[0].offsetLeft;
  };

  document.addEventListener('pointerdown', (event) => {
    if (event.pointerType !== 'mouse' || event.button !== 0) return;

    const slider = event.target.closest(SLIDER_SELECTOR);
    if (!slider || !slideOffset(slider)) return;

    drag = {
      slider,
      pointerId: event.pointerId,
      startX: event.clientX,
      startScroll: slider.scrollLeft,
      moved: false,
    };
  });

  document.addEventListener('pointermove', (event) => {
    if (!drag || event.pointerId !== drag.pointerId) return;

    const delta = event.clientX - drag.startX;
    if (!drag.moved) {
      if (Math.abs(delta) < DRAG_THRESHOLD) return;
      drag.moved = true;
      drag.slider.classList.add('is-dragging');
      if (drag.slider.setPointerCapture) drag.slider.setPointerCapture(event.pointerId);
    }

    event.preventDefault();
    drag.slider.scrollLeft = drag.startScroll - delta;
  });

  const endDrag = (event) => {
    if (!drag || (event && event.pointerId !== drag.pointerId)) return;

    const { slider, moved } = drag;
    drag = null;
    slider.classList.remove('is-dragging');
    if (!moved) return;

    // Ignore the click the browser fires after the drag, so dragging from a
    // product link does not navigate.
    suppressClickUntil = Date.now() + 300;

    const offset = slideOffset(slider);
    if (!offset) return;

    // Keep snapping off until the smooth scroll settles, otherwise the browser
    // jumps to the snap point instead of animating to it.
    slider.classList.add('is-snapping');
    slider.scrollTo({ left: Math.round(slider.scrollLeft / offset) * offset, behavior: 'smooth' });
    setTimeout(() => slider.classList.remove('is-snapping'), SNAP_DELAY);
  };

  document.addEventListener('pointerup', endDrag);
  document.addEventListener('pointercancel', endDrag);

  document.addEventListener('dragstart', (event) => {
    if (drag && event.target.closest(SLIDER_SELECTOR)) event.preventDefault();
  });

  document.addEventListener(
    'click',
    (event) => {
      if (Date.now() > suppressClickUntil) return;
      if (!event.target.closest(SLIDER_SELECTOR)) return;
      suppressClickUntil = 0;
      event.preventDefault();
      event.stopPropagation();
    },
    true
  );
}
